/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import classnames from 'classnames';

import VaultViewTab from './VaultViewTab';
import { AppContext } from '../AppContext'

import { css } from '@emotion/react';
import { RingLoader } from 'react-spinners'

class VaultView extends React.Component
{
  static contextType = AppContext;

  gatewayEnabled = undefined;
  tabTypes = ['cataloged', 'uncataloged', 'deleted', 'shared'];
  filterDataLS = 'vaultViewTab.filterData';
  matchAnyOrAllLS = 'vaultViewTab.matchAnyOrAll';
  activeTabLS = 'vaultViewTab.activeTab';
  sharedOptionLS = 'vaultViewTab.sharedOption';
  resetQueryFilters = false;
  viewTabCount = 4;

  addFilter(tabIndex)
  {
    let filterData = this.state.filterData;
    let filterIndex = filterData[tabIndex].length;

    filterData[tabIndex][filterIndex] = {queryKeyword: null, queryValue: null, operator: {label: '=', value: '='}};
    this.setState({filterData: filterData}, this.fetchKeywords.bind(this, tabIndex, filterIndex));
  }

  autoQueryVaultView(tabIndex, refresh)
  {
    if (this.resetQueryFilters)
    {
      this.resetQueryFilters = false;
      this.clearAllFilters(tabIndex, true)
      this.context.postNotification('warning', 'A search parameter no longer exists. Search terms reset.');
    }

    if ('Y' === this.context.userUiProfile.autoQueryEnabled || refresh)
    {
      this.fetchVaultViewData(tabIndex);
      if (1 !== tabIndex) this.fetchAllKeywordsAndValues(tabIndex);
    }
  }

  buildObjectTypeLS(tabIndex)
  {
    return 'vaultViewTab.' + tabIndex + '.selectedObjectType'
  }

  clearAllFilters(tabIndex, disableAutoQuery)
  {
    let filterData = this.state.filterData;
    let newData = [];
    newData[0] = {queryKeyword: null, queryValue: null, operator: {label: '=', value: '='}};
    filterData[tabIndex] = newData;

    let matchAnyOrAllArray = this.state.matchAnyOrAllArray;
    matchAnyOrAllArray[tabIndex] = 'All';

    if (undefined === disableAutoQuery || disableAutoQuery) this.autoQueryVaultView(tabIndex, false);
    this.context.appLocalStorage.setItem(this.filterDataLS, JSON.stringify(filterData));          
    this.context.appLocalStorage.setItem(this.matchAnyOrAllLS, JSON.stringify(matchAnyOrAllArray));
    this.setState({filterData: filterData, matchAnyOrAllArray: matchAnyOrAllArray});
  }

  async componentDidMount()
  {
    var filterData = [];

    let savedData = this.context.appLocalStorage.getItem(this.filterDataLS);
    if (null !== savedData && 'null' !== savedData)
    {
      filterData = JSON.parse(savedData);
      if (undefined === filterData[0][0].operator) filterData[0][0].operator = {label: '=', value: '='};
      if (undefined === filterData[2][0].operator) filterData[2][0].operator = {label: '=', value: '='};
      if (undefined === filterData[3][0].operator) filterData[3][0].operator = {label: '=', value: '='};
    }
    else
    {
      filterData[0] = [];
      filterData[0][0] = {queryKeyword: null, queryValue: null, operator: {label: '=', value: '='}};
      filterData[2] = [];
      filterData[2][0] = {queryKeyword: null, queryValue: null, operator: {label: '=', value: '='}};
      filterData[3] = [];
      filterData[3][0] = {queryKeyword: null, queryValue: null, operator: {label: '=', value: '='}};
    }

    var activeTab = Number(this.context.appLocalStorage.getItem(this.activeTabLS));
    if (null === activeTab || undefined === activeTab) activeTab = 0;

    let sharedOption = {option: 'All Shared Objects'};
    savedData = this.context.appLocalStorage.getItem(this.sharedOptionLS);
    if (null !== savedData && 'null' !== savedData) sharedOption = JSON.parse(savedData);

    var matchAnyOrAllArray;
    if (null !== this.context.appLocalStorage.getItem(this.matchAnyOrAllLS) && 'null' !== this.context.appLocalStorage.getItem(this.matchAnyOrAllLS))
    {
      matchAnyOrAllArray = JSON.parse(this.context.appLocalStorage.getItem(this.matchAnyOrAllLS));
    }
    else
    {
      matchAnyOrAllArray = [];
      matchAnyOrAllArray[0] = 'All';
      matchAnyOrAllArray[2] = 'All';
      matchAnyOrAllArray[3] = 'All';
    }

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getEnabledObjectTypes');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error enrolling content');

    let objectTypePickerData = [];
    objectTypePickerData[0] = {'objectType': 'All Object Types', 'objectTypeId': 0, selected: true, index: 0};
    for (let x = 0; x <  result.jsonData.enabledObjectTypes.length; x++)
    {
      objectTypePickerData[x+1] =  result.jsonData.enabledObjectTypes[x]
      objectTypePickerData[x+1].selected = false;
      objectTypePickerData[x+1].index = x+1;
    } 
    let tabFilePickerData = [];

    for (let x = 0; x < this.viewTabCount; x++)
    {
      tabFilePickerData[x] = JSON.parse(JSON.stringify(objectTypePickerData));

      let selectedObjectTypes = this.context.appLocalStorage.getItem(this.buildObjectTypeLS(x));
      if (null !== selectedObjectTypes && 'null' !== selectedObjectTypes)
      {
        selectedObjectTypes = JSON.parse(selectedObjectTypes);
        let filePickerData = tabFilePickerData[x];
        for (let y = 0; y < selectedObjectTypes.length; y++)
        {
          for (let z = 1; z < filePickerData.length; z++)
          {
            if (selectedObjectTypes[y] === filePickerData[z].objectType)
            {
              filePickerData[0].selected = false;
              filePickerData[z].selected = true;
            } 
          }
        }
        tabFilePickerData[x] = filePickerData;
      }
    }

    this.setState(
    {
      tabFilePickerData: tabFilePickerData,
      filterData: filterData,
      tabIndex: activeTab,
      sharedOption: sharedOption,
      matchAnyOrAllArray: matchAnyOrAllArray
    }, this.componentDidMountPhase2);
  }
  
  async componentDidMountPhase2()
  {
    await this.fetchAllKeywordsAndValues(this.state.tabIndex);
    this.autoQueryVaultView(this.state.tabIndex, false);
  }

  constructor(props)
  {
    super();

    this.state =
    {
      tabIndex: undefined,
      tabData: [],
      tabFilePickerData: [],
      filterData: [[], [], [], []],
      matchAnyOrAllArray: [],
      tabSelectedKeywords: [],
      tabQueryKeywords: [[], [], [], []],
      tabQueryValues: [],
      spinnerIsSpinning: false,
      sharedOption: {option: 'All Shared Objects'}
    }

    this.refreshTab = this.refreshTab.bind(this);
    this.addFilter = this.addFilter.bind(this);
    this.clearAllFilters = this.clearAllFilters.bind(this);
    this.fetchVaultViewData = this.fetchVaultViewData.bind(this);
    this.saveVaultViewData = this.saveVaultViewData.bind(this);
    this.toggleGateway = this.toggleGateway.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.transformObject = this.transformObject.bind(this);
    this.matchAnyOrAllChanged = this.matchAnyOrAllChanged.bind(this);
    this.objectTypePickerChanged = this.objectTypePickerChanged.bind(this);
    this.filterDataChanged = this.filterDataChanged.bind(this);
    this.fetchKeywords = this.fetchKeywords.bind(this);
    this.fetchAllKeywordsAndValues = this.fetchAllKeywordsAndValues.bind(this);
    this.fetchKeywordValues = this.fetchKeywordValues.bind(this);
    this.refreshQueryValues = this.refreshQueryValues.bind(this);
    this.sharedOptionChanged = this.sharedOptionChanged.bind(this);
    this.saveQueryValues = this.saveQueryValues.bind(this);
    this.saveVaultViewData = this.saveVaultViewData.bind(this);
    this.componentDidMountPhase2 = this.componentDidMountPhase2.bind(this);
  }

  async fetchAllKeywordsAndValues(tabIndex)
  {
    if (1 === tabIndex) return;

    let filterData = this.state.filterData[tabIndex];
    for (let x = 0; x < filterData.length; x++)
    {
      await this.fetchKeywords(tabIndex, x);
      if (null !== filterData[x].queryKeyword) await this.fetchKeywordValues(tabIndex, x);
    }
  }

  async fetchKeywords(tabIndex, filterIndex)
  {
    var bodyData = {objectTypeIds: [], selectedKeywordsAndValues: []};

    let objectTypePickerData = this.state.tabFilePickerData[tabIndex];
    if (!objectTypePickerData[0].selected)
    {
      let objectTypeIds = [];
      for (let x = 1; x < objectTypePickerData.length; x++)
        if (objectTypePickerData[x].selected)
          objectTypeIds[objectTypeIds.length] = objectTypePickerData[x].objectTypeId;

      bodyData.objectTypeIds = objectTypeIds;
    }

    if (filterIndex)                              // No need to check for keyword exclusion if we only have one keyword.
    {
      let queryFilters = this.state.filterData[tabIndex]; 

      if (null !== queryFilters[0].queryKeyword)
      {
        let selectedKeywordsAndValues = [];

        for (let y = 0; y < queryFilters.length; y++)
        {
          let selectedKeywordAndValue = {keywordId: null, valueId: null};
          if (null !== queryFilters[y].queryKeyword)
          {
            selectedKeywordAndValue.keywordId = queryFilters[y].queryKeyword.keywordId;
            if (null !== queryFilters[y].queryValue) selectedKeywordAndValue.valueId = queryFilters[y].queryValue.valueId;
            selectedKeywordsAndValues[selectedKeywordsAndValues.length] = selectedKeywordAndValue;
          } 
        }
  
        bodyData.selectedKeywordsAndValues = selectedKeywordsAndValues;
      }
    }

    bodyData.viewType = this.tabTypes[tabIndex];
    bodyData.matchAnyOrAll = this.state.matchAnyOrAllArray[tabIndex];

    if ('shared' === this.tabTypes[tabIndex]) bodyData.sharedOption = this.state.sharedOption.option;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getQueryKeywords', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error fetching query keywords');

    let tabQueryKeywords = this.state.tabQueryKeywords;
    if (undefined === tabQueryKeywords[tabIndex]) tabQueryKeywords[tabIndex] = [];
    tabQueryKeywords[tabIndex][filterIndex] = result.jsonData.queryKeywords;

    if (!filterIndex)
    {
      let queryFilters = this.state.filterData[tabIndex];
      this.resetQueryFilters = false;
      for (let x = 0; x < queryFilters.length; x++)
      {
        if (null !== queryFilters[x].queryKeyword)
        {
          let found = false;
          for (let y = 0; y < result.jsonData.queryKeywords.length; y++)
          {
            if (queryFilters[x].queryKeyword.keywordId === result.jsonData.queryKeywords[y].keywordId)
            {
              found = true;
              break;
            }
          }
          if (!found) this.resetQueryFilters = true
        }
      }
    }

    this.setState({tabQueryKeywords: tabQueryKeywords});
  }

  async fetchKeywordValues(tabIndex, filterIndex)
  {
    var bodyData = {keywordId: null, viewType: this.tabTypes[tabIndex], selectedKeywordValues: []};
    let filterData = this.state.filterData[tabIndex];

    bodyData.keywordId = filterData[filterIndex].queryKeyword.keywordId;
  
    if (filterIndex)                              
    {
      for (let x = 0; x < filterIndex; x++) bodyData.selectedKeywordValues[x] = filterData[x].queryValue.valueId;
    }

    let url = 'getKeywordValues';

    if ('shared' === this.tabTypes[tabIndex])
    {
      bodyData.sharedOption = this.state.sharedOption.option;
      url = 'getSharedKeywordValues';
    }

    bodyData.matchAnyOrAll = this.state.matchAnyOrAllArray[tabIndex];

    let result = await this.context.dbTwig.callRestAPI('dgBunker', url, bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading assigned values');
    this.saveQueryValues(filterData[filterIndex].queryKeyword.keywordValueType, tabIndex, filterIndex, result.jsonData.keywordValues);
  }

  async fetchVaultViewData(tabIndex)
  {
    var bodyData = {objectTypeIds: [], selectedKeywordsAndValues: [], sharedOption: null};

    if (undefined !== this.state.tabFilePickerData[tabIndex] && !this.state.tabFilePickerData[tabIndex][0].selected)
    {
      let objectTypeIds = [];

      for (let x = 0; x < this.state.tabFilePickerData[tabIndex].length; x++)
      {
        if (this.state.tabFilePickerData[tabIndex][x].selected) 
          objectTypeIds[objectTypeIds.length] = this.state.tabFilePickerData[tabIndex][x].objectTypeId;
      }

      bodyData.objectTypeIds = objectTypeIds;
    }

    if ('shared' === this.tabTypes[tabIndex]) bodyData.sharedOption = this.state.sharedOption.option;

    if ('uncataloged' !== this.tabTypes[tabIndex])
    {
      let queryFilters = this.state.filterData[tabIndex]; 

      if (null !== queryFilters[0].queryKeyword)
      {
        let selectedKeywordsAndValues = [];

        for (let y = 0; y < queryFilters.length; y++)
        {
          let selectedKeywordAndValue = {keywordId: null, valueId: null, operator: queryFilters[y].operator.value};
          if (null !== queryFilters[y].queryKeyword)
          {
            selectedKeywordAndValue.keywordId = queryFilters[y].queryKeyword.keywordId;
            if (null !== queryFilters[y].queryValue) selectedKeywordAndValue.valueId = queryFilters[y].queryValue.valueId;
            selectedKeywordsAndValues[selectedKeywordsAndValues.length] = selectedKeywordAndValue;
          } 
        }
  
        bodyData.selectedKeywordsAndValues = selectedKeywordsAndValues;
      }
    }

    bodyData.viewType = this.tabTypes[tabIndex];
    bodyData.matchAnyOrAll = this.state.matchAnyOrAllArray[tabIndex];

    this.setState({spinnerIsSpinning: true});

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getObjects', bodyData);
    if ('success' !== result.status)
    {
      this.setState({spinnerIsSpinning: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error loading object list');
    } 
    this.saveVaultViewData(tabIndex, result.jsonData.vaultObjects);
  }

  filterDataChanged(tabIndex, filterIndex, newFilterData)
  {
    let filterData = this.state.filterData;
    let oldFilterData = filterData[tabIndex][filterIndex];

    if (null === newFilterData.queryKeyword && filterIndex)
      filterData[tabIndex].splice(filterIndex, 1);
    else      
    {
      filterData[tabIndex][filterIndex] = newFilterData;
      if (filterIndex < filterData[tabIndex].length) filterData[tabIndex].splice(filterIndex + 1);
    }

    this.setState({filterData: filterData}, this.autoQueryVaultView(tabIndex, false));
    
    this.context.appLocalStorage.setItem(this.filterDataLS, JSON.stringify(filterData));          
    
    if (null === newFilterData.queryKeyword) return;

    if (null === oldFilterData)
    {
      this.fetchKeywordValues(tabIndex, filterIndex);
      return;
    }

    if (newFilterData.queryKeyword !== oldFilterData.queryKeyword) 
      this.fetchKeywordValues(tabIndex, filterIndex);
  }

  matchAnyOrAllChanged(tabIndex, matchAnyOrAll)
  {
    let matchAnyOrAllArray = this.state.matchAnyOrAllArray;
    matchAnyOrAllArray[tabIndex] = matchAnyOrAll;
    this.setState({matchAnyOrAllArray: matchAnyOrAllArray}, this.autoQueryVaultView(tabIndex, false));
    this.context.appLocalStorage.setItem(this.matchAnyOrAllLS, JSON.stringify(matchAnyOrAllArray));
    this.fetchKeywords(tabIndex, this.state.filterData.length - 1);
  }

  objectTypePickerChanged(tabIndex, selectedOption)
  {
    let objectTypePickerData = this.state.tabFilePickerData[tabIndex];

    if (!selectedOption.index)
    {
      for (let x = 0; x < objectTypePickerData.length; x++) objectTypePickerData[x].selected = false;
      objectTypePickerData[0].selected = true;
    }
    else
    {
      objectTypePickerData[selectedOption.index].selected = !objectTypePickerData[selectedOption.index].selected;
      let selected = 0;
      for (let x = 1; x < objectTypePickerData.length; x++) if (objectTypePickerData[x].selected) selected++;
      if (!selected) 
        objectTypePickerData[0].selected = true;
      else
        objectTypePickerData[0].selected = false;
    }
    
    let tabFilePickerData = this.state.tabFilePickerData;
    tabFilePickerData[tabIndex] = objectTypePickerData;

    this.setState({tabFilePickerData: tabFilePickerData});

    let selectedObjectTypes = [];
    for (let x = 0; x < objectTypePickerData.length; x++)
    {
      if (objectTypePickerData[x].selected) selectedObjectTypes.push(objectTypePickerData[x].objectType);
    }

    let selectedObjectTypesLS = this.buildObjectTypeLS(tabIndex);
    this.context.appLocalStorage.setItem(selectedObjectTypesLS, JSON.stringify(selectedObjectTypes));

    this.autoQueryVaultView(tabIndex, false);
    if ('uncataloged' !== this.tabTypes[tabIndex]) this.fetchAllKeywordsAndValues(tabIndex);
  }  

  refreshAllKeywordsAndValues()
  {
    this.fetchAllKeywordsAndValues(0);
    this.fetchAllKeywordsAndValues(2);
    if ('Y' === this.context.websiteProfile.sharingEnabled && this.context.userSession.viewSharedObjectsGranted(this.context.userUiProfile.grantedPermissions))
      this.fetchAllKeywordsAndValues(3);
  }

  refreshQueryValues(keywordId)
  {
    let filterData = this.state.filterData[0];
    for (let x = 0; x < filterData.length; x++)
    {
      if (null !== filterData[x].queryKeyword && filterData[x].queryKeyword && 
          filterData[x].queryKeyword.keywordId === keywordId)
        this.fetchKeywordValues(0, x);
    }

    filterData = this.state.filterData[2];
    for (let x = 0; x < filterData.length; x++)
    {
      if (null !== filterData[x].queryKeyword && filterData[x].queryKeyword && 
          filterData[x].queryKeyword.keywordId === keywordId)
        this.fetchKeywordValues(2, x);
    }
  }

  async refreshTab()
  {
    await this.fetchAllKeywordsAndValues(this.state.tabIndex);
    this.autoQueryVaultView(this.state.tabIndex, true);
  }  

  render()
  {
    if (undefined === this.context.websiteProfile) return null;
    
    document.title = this.context.websiteProfile.profileName + ': Vault View';
    
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;
    
    return(
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 0 })}
              onClick={() => { this.toggleTab(0); }}
            >
              Search
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 1 })}
              onClick={() => { this.toggleTab(1); }}
            >
              Upload
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 2 })}
              onClick={() => { this.toggleTab(2); }}
            >
              Trash
            </NavLink>
          </NavItem>
        { ('Y' === this.context.websiteProfile.sharingEnabled && this.context.userSession.viewSharedObjectsGranted(this.context.userUiProfile.grantedPermissions) &&
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 3 })}
              onClick={() => { this.toggleTab(3); }}
            >
              Shared
            </NavLink>
          </NavItem>
          )
        }
        </Nav>      
        <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
          <RingLoader
            css={override}
            size={75}
            color={'#4A90E2'}
            loading={this.state.spinnerIsSpinning}
          />          
        </div>
        <TabContent activeTab={this.state.tabIndex}>
          <TabPane tabId={0}>
            <VaultViewTab viewType='cataloged'
              activeTab={this.state.tabIndex} tabIndex={0} vaultViewData={this.state.tabData[0]} objectTypePickerData={this.state.tabFilePickerData[0]} 
              refreshTab={this.refreshTab} transformObject={this.transformObject} toggleGateway={this.toggleGateway} 
              filterData={this.state.filterData[0]} refreshQueryValues={this.refreshQueryValues} addFilter={this.addFilter}
              filterDataChanged={this.filterDataChanged} objectTypePickerChanged={this.objectTypePickerChanged} clearAllFilters={this.clearAllFilters}
              queryKeywords={this.state.tabQueryKeywords[0]} saveQueryFilter={this.saveQueryFilter} removeQueryFilter={this.removeQueryFilter}
              fetchAllKeywordsAndValues={this.fetchAllKeywordsAndValues} queryValues={this.state.tabQueryValues[0]}
              matchAnyOrAllChanged={this.matchAnyOrAllChanged} matchAnyOrAll={this.state.matchAnyOrAllArray[0]} 
              installedExtensions={this.context.websiteProfile.installedExtensions}
            />
          </TabPane>
          <TabPane tabId={1}>
            <VaultViewTab viewType='uncataloged'
              activeTab={this.state.tabIndex} tabIndex={1} vaultViewData={this.state.tabData[1]} objectTypePickerData={this.state.tabFilePickerData[1]}  
              refreshTab={this.refreshTab} transformObject={this.transformObject} toggleGateway={this.toggleGateway} 
              objectTypePickerChanged={this.objectTypePickerChanged} refreshQueryValues={this.refreshQueryValues} fetchKeywords={this.fetchKeywords}
              queryKeywords={this.state.tabQueryKeywords[1]} installedExtensions={this.context.websiteProfile.installedExtensions}
            />                
          </TabPane>
          <TabPane tabId={2}>
            <VaultViewTab viewType='deleted'
              activeTab={this.state.tabIndex} tabIndex={2} vaultViewData={this.state.tabData[2]} objectTypePickerData={this.state.tabFilePickerData[2]}  
              refreshTab={this.refreshTab} transformObject={this.transformObject} toggleGateway={this.toggleGateway} 
              filterData={this.state.filterData[2]} refreshQueryValues={this.refreshQueryValues} addFilter={this.addFilter}
              filterDataChanged={this.filterDataChanged} objectTypePickerChanged={this.objectTypePickerChanged} clearAllFilters={this.clearAllFilters}
              queryKeywords={this.state.tabQueryKeywords[2]} saveQueryFilter={this.saveQueryFilter} removeQueryFilter={this.removeQueryFilter}
              fetchAllKeywordsAndValues={this.fetchAllKeywordsAndValues} queryValues={this.state.tabQueryValues[2]}
              matchAnyOrAllChanged={this.matchAnyOrAllChanged} matchAnyOrAll={this.state.matchAnyOrAllArray[2]}
            />
          </TabPane>
          { ('Y' === this.context.websiteProfile.sharingEnabled && this.context.userSession.viewSharedObjectsGranted(this.context.userUiProfile.grantedPermissions) &&
          <TabPane tabId={3}>
            <VaultViewTab viewType='shared'
              activeTab={this.state.tabIndex} tabIndex={3} vaultViewData={this.state.tabData[3]} objectTypePickerData={this.state.tabFilePickerData[3]} 
              refreshTab={this.refreshTab} transformObject={this.transformObject} toggleGateway={this.toggleGateway} 
              filterData={this.state.filterData[3]} refreshQueryValues={this.refreshQueryValues} addFilter={this.addFilter}
              filterDataChanged={this.filterDataChanged} objectTypePickerChanged={this.objectTypePickerChanged} clearAllFilters={this.clearAllFilters}
              queryKeywords={this.state.tabQueryKeywords[3]} saveQueryFilter={this.saveQueryFilter} removeQueryFilter={this.removeQueryFilter}
              fetchAllKeywordsAndValues={this.fetchAllKeywordsAndValues} queryValues={this.state.tabQueryValues[3]} 
              sharedOption={this.state.sharedOption} sharedOptionChanged={this.sharedOptionChanged}
              matchAnyOrAllChanged={this.matchAnyOrAllChanged} matchAnyOrAll={this.state.matchAnyOrAllArray[3]}
            />
          </TabPane>
          )
        }
        </TabContent>        
      </div>
    );
  }
 
  saveQueryValues(keywordValueType, tabIndex, filterIndex, keywordValues)
  {
    if ('date' === keywordValueType)
      for (let i = 0; i < keywordValues.length; i++) keywordValues[i].keywordValue = window.moment.unix(keywordValues[i].keywordValue).utc().format('LL');

    if ('timestamp' === keywordValueType) 
      for (let i = 0; i < keywordValues.length; i++) keywordValues[i].keywordValue = window.moment.unix(keywordValues[i].keywordValue).utc().format('LL LTS');

    if ('time' === keywordValueType) 
      for (let i = 0; i < keywordValues.length; i++) keywordValues[i].keywordValue = window.moment.unix(keywordValues[i].keywordValue).utc().format('LTS');

    var queryValues = this.state.tabQueryValues;
    if (undefined === queryValues[tabIndex]) queryValues[tabIndex] = [];
    queryValues[tabIndex][filterIndex] =  keywordValues;
    this.setState({tabQueryValues: queryValues});
  }

  saveVaultViewData(tabIndex, vaultViewData)
  {
    var tabData = this.state.tabData;
    tabData[tabIndex] =  vaultViewData;
    this.setState({tabData: tabData, spinnerIsSpinning: false});
  }

  sharedOptionChanged(sharedOption)
  {
    this.setState({sharedOption: sharedOption}, function ()
    {
      let tabIndex = this.tabTypes.indexOf('shared');
      this.autoQueryVaultView(tabIndex, false);
      this.fetchAllKeywordsAndValues(tabIndex);
    });

    this.context.appLocalStorage.setItem(this.sharedOptionLS, JSON.stringify(sharedOption));          
  }

  async toggleGateway()
  {
    let url = 'enableDropDirectory';

    let bodyData = {};
    bodyData.gatewayName = this.context.appLocalStorage.getGatewayName();

    if (this.gatewayEnabled) url = 'disableDropDirectory';

    let result = await this.context.dbTwig.callRestAPI('dgBunker', url, bodyData);
    if ('success' !== result.status)
    {
      if (this.context.dbTwig.GatewayOffline === result.errorCode)
      {
        this.gatewayEnabled = undefined;
        this.context.postNotification('warning', 'Gateway Offline');
        return;
      }
      else
        return this.context.dbTwig.apiErrorHandler(result, 'Gateway Error');
    }

    this.gatewayEnabled =  !this.gatewayEnabled;
    this.context.postNotification('info', this.gatewayEnabled ? 'Gateway Enabled' : 'Gateway Disabled');
  }

  async toggleTab(tabIndex, tab)
  {
    if (this.state.tabIndex !== tabIndex)
    {
      await this.fetchAllKeywordsAndValues(tabIndex);
      this.autoQueryVaultView(tabIndex, false);
      this.setState({ tabIndex: tabIndex });
      this.context.appLocalStorage.setItem(this.activeTabLS, tabIndex);
    } 
  }

  transformObject(tabIndex, rowIndex)
  {
    let tabData = this.state.tabData;
    tabData[tabIndex][rowIndex].versionedObject = 'Y';
    this.setState({tabData: tabData});
  }
}

// VaultView.contextType = AppContext;

export default VaultView
